import { z } from 'zod'

export const ADMINPERSONABASEDELETE_CONTRACT_VERSION = '1.0.0' as const
export const adminPersonaBaseDeleteResponseSchema = z.unknown()
export type AdminPersonaBaseDeleteResponse = z.infer<typeof adminPersonaBaseDeleteResponseSchema>
